<template>
  <div class="EditorToolbar">
    <HeadingPicker :editor="editor"></HeadingPicker>

    <section>
      <AlignButtons :editor="editor"></AlignButtons>
    </section>

    <section>
      <FormatButtons :editor="editor"></FormatButtons>
    </section>

    <section>
      <ListButtons :editor="editor"></ListButtons>
    </section>

    <section>
      <ColorButtons :editor="editor"></ColorButtons>
    </section>

    <section>
      <LinkButton :editor="editor"></LinkButton>
      <ImageButton :editor="editor"></ImageButton>
      <TemplateButton :editor="editor"></TemplateButton>
    </section>

    <section>
      <HistoryButtons :editor="editor"></HistoryButtons>
    </section>

    <section>
      <ClearButton :editor="editor"></ClearButton>
      <PreviewButton :editor="editor"></PreviewButton>
      <SourceButton :editor="editor"></SourceButton>
    </section>
  </div>
</template>

<script>
import AlignButtons from './toolbar/AlignButtons.vue';
import ClearButton from './toolbar/ClearButton.vue';
import ColorButtons from './toolbar/ColorButtons.vue';
import FormatButtons from './toolbar/FormatButtons.vue';
import HeadingPicker from './toolbar/HeadingPicker.vue';
import HistoryButtons from './toolbar/HistoryButtons.vue';
import ImageButton from './toolbar/ImageButton.vue';
import LinkButton from './toolbar/LinkButton.vue';
import ListButtons from './toolbar/ListButtons.vue';
import PreviewButton from './toolbar/PreviewButton.vue';
import SourceButton from './toolbar/SourceButton.vue';
import TemplateButton from './toolbar/TemplateButton.vue';

export default {
  components: {
    AlignButtons,
    ClearButton,
    ColorButtons,
    FormatButtons,
    HeadingPicker,
    HistoryButtons,
    ImageButton,
    LinkButton,
    ListButtons,
    PreviewButton,
    SourceButton,
    TemplateButton,
  },

  props: {
    editor: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.UiInputHtmlTiptap {
  .EditorToolbar {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;

    border-bottom: 1px solid #ddd;

    & > section {
      display: flex;
      align-items: center;
      flex-direction: row;
      flex-wrap: nowrap;

      padding: 0 2px;
      border-right: 1px solid #ddd;

      &:last-child {
        border-right: 0;
      }
    }
  }

  .ToolbarButton {
    border: none;
    border-radius: 2px;
    width: 38px;
    height: 36px;
    background: transparent;
    cursor: pointer;

    &.is-active {
      color: white;
      background-color: #303030 !important;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    &.ui-icon {
      --ui-icon-size: 12pt;
    }
  }
}
</style>